<div [class.d-none]="_showContainer === false" [@shakeit]="this.states['shakeSubstitution']"
  (@shakeit.done)="shakeEnd('shakeSubstitution', $event)" class="switch-label compact-switch switch-txt-6"
  [formGroup]="_formGroup">
  <label class="switch" title="Ajusta tu disponibilidad para reemplazos">
    <input id="availability-job-replacement" type="checkbox" name="" class="show-modal-timetable-edit"
      formControlName='employeeSubstitution' />
    <span class="slider round"></span>
  </label>
  <div class="wrap-label">
    <div class="label">{{employeeSubstitution.value === true ? 'Disponible reemplazo' : 'No disponible reemplazo'}}
    </div>
    <div [id]="idLink" class="collapse ctn-collapse-control">
      <a class="link-collapse-control" role="button" (click)="onClickOpenModal($event)"
        title="Definir días y horarios para reemplazos">Definir horarios</a>
    </div>
  </div>
</div>